var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _c("div", { staticClass: "website-basket-padding border-bottom" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$resourceString["checkout.Project.Header"]) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("pc-salesforce-opportunities", {
          staticClass: "sfOpps",
          attrs: { "user-email": _vm.userEmail },
          on: {
            "contact-found": _vm.handleContactFound,
            "update-project-name": _vm.setProjectName
          }
        }),
        _vm._v(" "),
        !_vm.contactFound
          ? _c("div", { staticClass: "mt-3 pb-1 d-flex flex-column" }, [
              _c(
                "label",
                { staticClass: "d-inline-block font-16 font-weight-bold mr-2" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$resourceString["checkout.Project.Title"]) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.projectName,
                    expression: "projectName"
                  }
                ],
                staticClass:
                  "shipping-modal-input-field form-control col-lg-5 col-12",
                attrs: { placeholder: "Project Name*" },
                domProps: { value: _vm.projectName },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.projectName = $event.target.value
                    },
                    _vm.submitProjectName
                  ]
                }
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.getValidationErrorPName
                ? _c("span", { staticClass: "font-16 danger" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$resourceString[
                            "checkout.ProjectName.ValidationError"
                          ]
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }